import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    width: '100%',
    alignItems: 'center',
  },
});
